<div class="sc-standalone-page">
  <div class="app-page-title">
    <div class="page-title-wrapper">
      <div class="page-title-heading">
        <div class="page-title-icon">
          <i class="pe-7s-cash icon-gradient bg-mean-fruit"></i>
        </div>
        <div>
          Salary Confirmation
          <div class="page-title-subheading">Send salary credit details on WhatsApp and track each recipient's confirmation.</div>
        </div>
      </div>
    </div>
  </div>

  <div class="row align-items-start">
    <!-- ── Left: data entry form ─────────────────────────────────────────── -->
    <div class="col-xl-5 col-lg-5 mb-3">
      <div class="card sc-card">
        <div class="card-header">Send Confirmation Request</div>
        <div class="card-body">
          <div class="mb-3">
            <label class="form-label fw-semibold">Select message type</label>
            <div class="sc-type-row">
              <div *ngFor="let type of messageTypes" class="form-check sc-type-option">
                <input
                  class="form-check-input"
                  type="radio"
                  name="messageType"
                  [id]="'sc-type-' + type.value"
                  [value]="type.value"
                  [(ngModel)]="messageType"
                  (ngModelChange)="onMessageTypeChange()"
                />
                <label class="form-check-label" [for]="'sc-type-' + type.value">{{ type.label }}</label>
                <button
                  type="button"
                  class="sc-info-btn"
                  [class.active]="infoType === type.value"
                  [attr.aria-label]="'About ' + type.label"
                  [attr.aria-expanded]="infoType === type.value"
                  (click)="toggleInfo(type.value, $event)"
                >
                  i
                </button>
                <div *ngIf="infoType === type.value" class="sc-info-popover" role="tooltip" (click)="$event.stopPropagation()">
                  {{ type.hint }}
                  <div *ngIf="!isTypeEnabled(type.value)" class="text-warning mt-1">WhatsApp Flow not configured yet.</div>
                </div>
              </div>
            </div>
          </div>

          <!-- Employee details -->
          <div class="mb-3">
            <label class="form-label fw-semibold">Employee Name</label>
            <input type="text" class="form-control" placeholder="e.g. Mr. KISHOR VASANT KOLI"
              [(ngModel)]="employeeName" />
          </div>

          <div class="row g-2 mb-3">
            <div class="col-5">
              <label class="form-label fw-semibold">Bank Name</label>
              <input type="text" class="form-control" placeholder="e.g. SBI"
                [(ngModel)]="bankName" />
            </div>
            <div class="col-7">
              <label class="form-label fw-semibold">Account Number</label>
              <input type="text" class="form-control" placeholder="e.g. 30800059564"
                [(ngModel)]="accountNo" />
            </div>
          </div>

          <!-- Salary entries -->
          <div class="mb-3">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <label class="form-label fw-semibold mb-0">
                Salary / Transaction Entries
                <span class="text-muted fw-normal">({{ salaryEntries.length }}/{{ maxEntries }})</span>
              </label>
              <button type="button" class="btn btn-sm btn-outline-primary"
                (click)="addEntry()" [disabled]="salaryEntries.length >= maxEntries">
                + Add Row
              </button>
            </div>

            <!-- Header row -->
            <div class="sc-entry-header">
              <span class="sc-entry-col-date">Date</span>
              <span class="sc-entry-col-desc">Description</span>
              <span class="sc-entry-col-amt">Amount (CR)</span>
              <span class="sc-entry-col-del"></span>
            </div>

            <div *ngFor="let entry of salaryEntries; let i = index; trackBy: trackByIndex"
              class="sc-entry-row">
              <label class="sc-date-picker sc-entry-col-date">
                <span [class.sc-date-empty]="!entry.date">
                  {{ entry.date ? formatDateDisplay(entry.date) : 'dd/mm/yy' }}
                </span>
                <svg width="13" height="13" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
                  <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
                </svg>
                <input type="date" [(ngModel)]="entry.date" />
              </label>
              <input type="text" class="form-control form-control-sm sc-entry-col-desc"
                placeholder="SALARY AUG" [(ngModel)]="entry.description" />
              <input type="text" class="form-control form-control-sm sc-entry-col-amt"
                placeholder="38,257.00" [(ngModel)]="entry.amount" />
              <button type="button" class="btn btn-sm btn-outline-danger sc-entry-col-del"
                (click)="removeEntry(i)" [disabled]="salaryEntries.length === 1" title="Remove">
                &times;
              </button>
            </div>
          </div>

          <!-- WhatsApp preview (computed from structured fields) -->
          <div *ngIf="composedMessage.trim()" class="mb-3">
            <label class="form-label fw-semibold">
              Message Preview
              <small class="text-muted fw-normal ms-2">{{ composedMessage.length }} / {{ maxMessageLength }}</small>
            </label>
            <div class="sc-preview">
              <div class="sc-bubble">
                <div class="sc-bubble-text">{{ composedMessage }}</div>
                <ng-container [ngSwitch]="messageType">
                  <div *ngSwitchCase="'CONFIRMATION'" class="sc-bubble-actions">
                    <span>OK</span>
                    <span>Not OK</span>
                  </div>
                  <div *ngSwitchCase="'INDIVIDUAL'">
                    <div class="sc-bubble-actions"><span>Review entries</span></div>
                    <ul class="sc-checklist">
                      <li *ngFor="let item of filledItems">☐ {{ item }}</li>
                    </ul>
                  </div>
                  <div *ngSwitchCase="'FLOW'" class="sc-bubble-actions"><span>Open form</span></div>
                </ng-container>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <label for="sc-mobile" class="form-label fw-semibold">Enter WhatsApp number</label>
            <input
              id="sc-mobile"
              type="tel"
              class="form-control"
              placeholder="10-digit mobile number or with country code"
              [(ngModel)]="recipientNo"
              (keyup.enter)="canSend && send()"
            />
          </div>

          <div *ngIf="formError" class="alert alert-danger py-2">{{ formError }}</div>
          <div *ngIf="formWarning" class="alert alert-warning py-2">{{ formWarning }}</div>
          <div *ngIf="formSuccess" class="alert alert-success py-2">{{ formSuccess }}</div>

          <div class="d-flex gap-2">
            <button type="button" class="btn btn-primary" [disabled]="!canSend" (click)="send()">
              <span *ngIf="isSending" class="spinner-border spinner-border-sm me-1"></span>
              Send
            </button>
            <button type="button" class="btn btn-outline-secondary" (click)="resetForm()" [disabled]="isSending">Clear</button>
          </div>
        </div>
      </div>
    </div>

    <!-- ── Right: sent messages and replies ──────────────────────────────── -->
    <div class="col-xl-7 col-lg-7 mb-3">
      <div class="card sc-card">
        <div class="card-header sc-history-header">
          <span>Sent Messages &amp; Replies ({{ total }})</span>
          <div class="d-flex gap-2 align-items-center">
            <input
              type="search"
              class="form-control form-control-sm sc-search"
              placeholder="Search number / text"
              [(ngModel)]="search"
              (keyup.enter)="loadList()"
            />
            <select class="form-select form-select-sm sc-filter" [(ngModel)]="deliveryFilter" (ngModelChange)="loadList()">
              <option value="">All deliveries</option>
              <option *ngFor="let status of deliveryStatuses" [value]="status.value">{{ status.label }}</option>
            </select>
            <button type="button" class="btn btn-sm btn-outline-primary" (click)="loadList()" title="Refresh">
              <i class="pe-7s-refresh-2"></i>
            </button>
          </div>
        </div>
        <div class="card-body p-0">
          <div *ngIf="listError" class="alert alert-danger m-3">{{ listError }}</div>
          <div *ngIf="isLoadingList" class="text-center text-muted py-4">Loading...</div>
          <div *ngIf="!isLoadingList && !rows.length && !listError" class="text-center text-muted py-4">No messages sent yet.</div>

          <div *ngIf="rows.length" class="table-responsive sc-table-wrap">
            <table class="table table-hover align-middle mb-0 sc-table">
              <thead class="table-light">
                <tr>
                  <th class="sc-chevron-col"></th>
                  <th>Sent</th>
                  <th>Mobile</th>
                  <th>Message</th>
                  <th>Delivery</th>
                  <th>Reply</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let row of rows; trackBy: trackById">
                  <tr class="sc-row" (click)="toggleRow(row)" [class.sc-row-open]="expandedId === row._id">
                    <td class="sc-chevron-col"><span class="sc-chevron">&#8250;</span></td>
                    <td class="text-nowrap">{{ row.createdAt | date: 'dd/MM/yy HH:mm' }}</td>
                    <td class="text-nowrap">{{ row.recipientNo }}</td>
                    <td class="sc-message-cell" [title]="row.messageText">{{ row.messageText }}</td>
                    <td>
                      <span [class]="deliveryBadgeClass(row.deliveryStatus)">{{ row.deliveryStatus }}</span>
                    </td>
                    <td class="sc-reply-cell" [title]="row.lastReply?.text || ''">
                      <span *ngIf="row.lastReply; else noReply">{{ row.lastReply.text }}</span>
                      <ng-template #noReply><span class="text-muted">—</span></ng-template>
                    </td>
                  </tr>

                  <!-- Always rendered so the open/close height transition can run -->
                  <tr class="sc-detail-row" [class.open]="expandedId === row._id">
                    <td colspan="7">
                      <div class="sc-collapse" [attr.inert]="expandedId === row._id ? null : ''">
                        <div class="sc-collapse-inner">
                      <div class="row g-3 sc-detail-body">
                        <div class="col-md-6">
                          <div class="fw-semibold mb-1">Message</div>
                          <div class="sc-detail-text">{{ row.messageText }}</div>
                          <div class="small text-muted mt-2">
                            Sent as {{ row.sendMode === 'TEMPLATE' ? 'approved template' : row.sendMode === 'SESSION' ? 'session message' : '—' }}
                          </div>
                          <div *ngIf="row.deliveryStatus === 'FAILED'" class="text-danger small mt-1">
                            Failed: {{ row.failedReason || 'Unknown error' }}
                          </div>
                          <button
                            type="button"
                            class="btn btn-sm btn-outline-primary mt-2"
                            [disabled]="resendingId === row._id"
                            (click)="resend(row, $event)"
                          >
                            {{ resendingId === row._id ? 'Re-sending...' : 'Re-send' }}
                          </button>
                        </div>
                        <div class="col-md-6">
                          <div class="mb-2">
                            <span class="fw-semibold me-2">Result</span>
                            <span [class]="interpretationBadgeClass(row.interpretation)">
                              {{ interpretationLabels[row.interpretation] || row.interpretation }}
                            </span>
                          </div>
                          <ng-container *ngIf="row.messageType === 'INDIVIDUAL' && row.items.length">
                            <div class="fw-semibold mb-1">Entries</div>
                            <ul class="list-unstyled small mb-2">
                              <li *ngFor="let item of row.items">
                                <ng-container *ngIf="row.lastReply; else itemPending">
                                  <span [class]="isItemSelected(row, item.id) ? 'text-success' : 'text-danger'">
                                    {{ isItemSelected(row, item.id) ? '✔' : '✘' }}
                                  </span>
                                </ng-container>
                                <ng-template #itemPending><span class="text-muted">☐</span></ng-template>
                                {{ item.text }}
                              </li>
                            </ul>
                          </ng-container>
                          <ng-container *ngIf="row.messageType === 'FLOW' && row.confirmedDates?.length">
                            <div class="fw-semibold mb-1">Confirmed Dates</div>
                            <ul class="list-unstyled small mb-2">
                              <li *ngFor="let cd of row.confirmedDates" class="text-success">
                                ✔ {{ cd.entryDescription }}: {{ cd.confirmedDateDisplay }}
                              </li>
                            </ul>
                          </ng-container>
                          <div class="fw-semibold mb-1">Replies</div>
                          <div *ngIf="!row.replies.length" class="text-muted small">No reply yet.</div>
                          <div *ngFor="let reply of row.replies" class="small mb-1">
                            <span class="text-muted">{{ reply.receivedAt | date: 'dd/MM/yy HH:mm' }}</span>
                            — {{ reply.text || '(no text)' }}
                          </div>
                        </div>
                      </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
        <div *ngIf="lastRefreshedAt" class="card-footer small text-muted">
          Auto-refreshes every 15 seconds · Last updated {{ lastRefreshedAt | date: 'HH:mm:ss' }}
        </div>
      </div>
    </div>
  </div>
</div>
